import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  commentText: {
    fontSize: 13,
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },
}))

export default useStyles
